import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { DecisionLog } from '../../components/decisions/DecisionLog.tsx'

export const Route = createFileRoute('/_app/entscheidungen')({ component: DecisionsPage })

function DecisionsPage() {
  const { t } = useTranslation()
  return (
    <div className="min-w-0 flex-1 overflow-y-auto">
      <div className="mx-auto flex max-w-3xl flex-col gap-4 px-4 py-4 md:px-8 md:py-6">
        <header data-tauri-drag-region>
          <h1 className="text-[22px] text-text-1">{t('nav.decisions')}</h1>
          <p className="mt-1 text-[13px] text-text-2">{t('decisions.intro')}</p>
        </header>
        <DecisionLog />
      </div>
    </div>
  )
}
